import { render, staticRenderFns } from "./TkHotelReviewCommon.vue?vue&type=template&id=09f0b603&scoped=true&"
import script from "./TkHotelReviewCommon.vue?vue&type=script&lang=js&"
export * from "./TkHotelReviewCommon.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelReviewCommon.vue?vue&type=style&index=0&id=09f0b603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0b603",
  null
  
)

export default component.exports